export class ToastIconClasses {
  static Warning = 'alert-cstm-warning alert-holder-fixed';
  static Error = 'alert-cstm-danger alert-holder-fixed';
  static Info = 'alert-cstm-info alert-holder-fixed';
  static Success = 'alert-cstm-success alert-holder-fixed';
}
